import { render, staticRenderFns } from "./MigracaoPlanilha.vue?vue&type=template&id=781f612a&scoped=true"
import script from "./MigracaoPlanilha.vue?vue&type=script&lang=js"
export * from "./MigracaoPlanilha.vue?vue&type=script&lang=js"
import style0 from "./MigracaoPlanilha.vue?vue&type=style&index=0&id=781f612a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781f612a",
  null
  
)

export default component.exports